import { logger, safeError } from '../utils/logger';
import api from '../api/api';

export class ContratistaService {
  
  // Servicio para cargar contratistas por tipo de usuario
  static async findByTipoUsuario(idUsuario: number): Promise<any> {
    try {
      const response = await api.get(`/contratistas/byTipoUsuario?idUsuario=${idUsuario}`);
      return response.data;
    } catch (error: any) {
      logger.error('Error al cargar contratistas por tipo usuario:', safeError(error));
      throw error;
    }
  }

  // Método para obtener todos los contratistas (si necesitas uno general)
  static async getAll(): Promise<any> {
    try {
      const response = await api.get('/contratistas');
      return response.data;
    } catch (error: any) {
      logger.error('Error al cargar todos los contratistas:', safeError(error));
      throw error;
    }
  }
}